import { createAction } from 'redux-actions';

export const setForeignCardAction = createAction<boolean>('SET_FOREIGN_CARD_ACTION');
